var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDining = function SvgDining(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4281_4382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7984 15.5768V3.56152H29.1964V15.5768L21.4668 29.5819H54.528L46.7984 15.5768ZM42.2066 13.8932H33.7882V8.15336H42.2066V13.8932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4862 59.9639H12.0576V64.5557H18.4862V59.9639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4862 44.8877H12.0576V49.4795H18.4862V44.8877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5 41.0616V36.4697H49.0969H0.5V41.0616H3.56122V67.8473H0.5V72.4391H75.5V67.8473H72.4388V41.0616H75.5ZM22.3112 67.8473H8.15306V56.5973H22.3112V67.8473ZM22.3112 52.0054H8.15306V41.0616H22.3112V52.0054ZM67.8469 67.8473H53.6888V56.5973H67.8469V67.8473ZM67.8469 52.0054H53.6888V41.0616H67.8469V52.0054Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9432 59.9639H57.5146V64.5557H63.9432V59.9639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9432 44.8877H57.5146V49.4795H63.9432V44.8877Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4281_4382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDining);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dining.b44c28c2145a0652bb989b324888df2c.svg";